import { UserAvailabilityType } from '../../application/user/model/user-availability.type';

export interface IUserAvailability {
	readonly dayIndex: number;
	readonly endOffset: number;
	readonly startOffset: number;
	readonly type: UserAvailabilityType;
	readonly id: string;
}

export class UserAvailability implements IUserAvailability {
	private _dayIndex: number;
	private _endOffset: number;
	private _startOffset: number;
	private _type: UserAvailabilityType;
	private _id: string;

	constructor(
		dayIndex: number,
		endOffset: number,
		startOffset: number,
		type: UserAvailabilityType,
		id: string
	) {
		this._dayIndex = dayIndex;
		this._endOffset = endOffset;
		this._startOffset = startOffset;
		this._type = type;
		this._id = id;
	}

	public get id(): string {
		return this._id;
	}

	public get dayIndex(): number {
		return this._dayIndex;
	}

	public get endOffset(): number {
		return this._endOffset;
	}

	public get startOffset(): number {
		return this._startOffset;
	}

	public get type(): UserAvailabilityType {
		return this._type;
	}
}
